export default __webpack_public_path__ + "bdd3d12707761261caa35a9f6e3a2b9c.png";